
// import { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   ArrowLeft, Search, X, CheckCircle, AlertCircle,
//   Loader2, TrendingUp, RefreshCw, Download, ExternalLink,
//   BarChart2, Database, RotateCcw,
// } from "lucide-react";
// import { USER_API_END_POINT } from "@/utils/constant";
// import Footer from "../Footer";
// import Pagination from "./Pagination";

// const TABS = [
//   { id: "search", label: "Search Hirees", icon: Search },
//   { id: "analytics", label: "Analytics", icon: BarChart2 },
// ];

// function mapCeipalRecordToCandidate(item, index) {
//   const rawSkills = item.primary_skills || item.skills || "";
//   const skills = Array.isArray(rawSkills)
//     ? rawSkills
//     : String(rawSkills).split(",").map((s) => s.trim()).filter(Boolean);

//   return {
//     id: item.applicant_id || item.id || `ceipal-${index}`,
//     name: [item.first_name, item.middle_name, item.last_name].filter(Boolean).join(" ") || "Unknown",
//     email: item.email_address || null,
//     phone: item.mobile_number || item.work_phone_number || item.home_phone_number || null,
//     jobTitle: item.job_title || "",
//     experience: item.experience ? Number(item.experience) : null,
//     skills,
//     visaType: item.work_authorization || "Unspecified",
//     location: [item.city, item.state, item.country].filter(Boolean).join(", "),
//     linkedinUrl: item.linkedin_profile_url || null,
//     ceipalProfileUrl: item.profile_url || null,
//     updatedAt: item.resume_updated_on || item.modified_date || null,
//     resumeToken: item.resume_token || null,
//   };
// }

// // Default filters — empty means "no filter applied", used both on first load
// // and whenever the user hits Reset + Search again.
// const EMPTY_FILTERS = {
//   keywords: "",
//   jobTitle: "",
//   country: "",
//   state: "",
//   city: "",
// };

// const CeipalDBPage = () => {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState("search");

//   const [keywords, setKeywords] = useState("");
//   const [jobTitleInput, setJobTitleInput] = useState("");
//   const [country, setCountry] = useState("");
//   const [stateInput, setStateInput] = useState("");
//   const [city, setCity] = useState("");

//   // IMPORTANT: appliedFilters now starts as EMPTY_FILTERS (not null) so that
//   // the data-fetch effect below fires immediately on page load, pulling the
//   // full (paginated) dataset with no filters applied.
//   const [appliedFilters, setAppliedFilters] = useState(EMPTY_FILTERS);

//   const [candidates, setCandidates] = useState([]);
//   const [totalCount, setTotalCount] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(20);

//   const [selectedIds, setSelectedIds] = useState(new Set());
//   const toggleSelectAll = () => {
//     setSelectedIds((prev) =>
//       prev.size === candidates.length ? new Set() : new Set(candidates.map((c) => c.id))
//     );
//   };
//   const toggleRow = (id) => {
//     setSelectedIds((prev) => {
//       const next = new Set(prev);
//       next.has(id) ? next.delete(id) : next.add(id);
//       return next;
//     });
//   };

//   const [analytics, setAnalytics] = useState(null);
//   const [analyticsLoading, setAnalyticsLoading] = useState(false);
//   const [analyticsError, setAnalyticsError] = useState(null);

//   const fetchCandidates = useCallback(async (filters, page, size) => {
//     setLoading(true);
//     setError(null);
//     try {
//       // Build params with job_title first so it's always the leading/primary
//       // filter sent to the backend, followed by the rest in order.
//       const params = new URLSearchParams({
//         page,
//         pageSize: size,
//         ...(filters.jobTitle ? { jobTitle: filters.jobTitle } : {}),
//         ...(filters.keywords ? { keywords: filters.keywords } : {}),
//         ...(filters.country ? { country: filters.country } : {}),
//         ...(filters.state ? { state: filters.state } : {}),
//         ...(filters.city ? { city: filters.city } : {}),
//       });

//       const res = await fetch(`${USER_API_END_POINT}/ceipal/candidates?${params}`, {
//         credentials: "include",
//       });
//       const data = await res.json();

//       if (!data.success) throw new Error(data.message || "Failed to load Ceipal candidates");

//       const list = Array.isArray(data.results) ? data.results : data.data || [];
//       setCandidates(list.map(mapCeipalRecordToCandidate));
//       setTotalCount(data.total ?? list.length);
//     } catch (err) {
//       console.error("Error fetching Ceipal candidates:", err);
//       setError(err.message || "Failed to load Ceipal candidates");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   // Runs on mount (appliedFilters starts populated) AND whenever filters,
//   // page, or page size change afterwards.
//   useEffect(() => {
//     fetchCandidates(appliedFilters, currentPage, pageSize);
//   }, [appliedFilters, currentPage, pageSize, fetchCandidates]);

//   useEffect(() => {
//     setSelectedIds(new Set());
//   }, [candidates]);

//   useEffect(() => {
//     if (activeTab !== "analytics") return;
//     const fetchAnalytics = async () => {
//       setAnalyticsLoading(true);
//       setAnalyticsError(null);
//       try {
//         const res = await fetch(`${USER_API_END_POINT}/ceipal/analytics`, { credentials: "include" });
//         const data = await res.json();
//         if (!data.success) throw new Error(data.message || "Failed to load analytics");
//         setAnalytics(data.analytics);
//       } catch (err) {
//         setAnalyticsError(err.message || "Failed to load analytics");
//       } finally {
//         setAnalyticsLoading(false);
//       }
//     };
//     fetchAnalytics();
//   }, [activeTab]);

//   const handleSearch = () => {
//     setCurrentPage(1);
//     setAppliedFilters({
//       // job_title is the primary filter — put first for clarity, though
//       // object key order doesn't affect behavior, fetchCandidates handles priority.
//       jobTitle: jobTitleInput.trim(),
//       keywords: keywords.trim(),
//       country: country.trim(),
//       state: stateInput.trim(),
//       city: city.trim(),
//     });
//   };

//   const handleReset = () => {
//     setKeywords("");
//     setJobTitleInput("");
//     setCountry("");
//     setStateInput("");
//     setCity("");
//     setCurrentPage(1);
//     // Reset also re-triggers a full, unfiltered load immediately.
//     setAppliedFilters(EMPTY_FILTERS);
//   };

//   const handleRefresh = () => {
//     fetchCandidates(appliedFilters, currentPage, pageSize);
//   };

//   const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
//   const handlePageChange = (page) => setCurrentPage(page);
//   const handlePageSizeChange = (size) => {
//     setPageSize(parseInt(size, 10));
//     setCurrentPage(1);
//   };

//   const inputCls =
//     "w-full text-sm text-gray-700 placeholder-gray-400 bg-transparent outline-none";
//   const fieldWrapCls =
//     "flex flex-col gap-1 bg-white rounded-xl px-3 py-2 shadow-sm border border-white/10";
//   const labelCls = "text-[9px] font-bold uppercase tracking-widest text-gray-400";

//   return (
//     <>
//       <div className="min-h-screen bg-[#f8f9fc]">
//         {/* ── Hero ──────────────────────────────────────────────────────── */}
//         <div className="relative w-full overflow-hidden">
//           <div className="absolute inset-0 bg-[#012760]" />
//           <div
//             className="absolute inset-0 opacity-[0.07]"
//             style={{
//               backgroundImage: "radial-gradient(circle, #ffffff 1px, transparent 1px)",
//               backgroundSize: "28px 28px",
//             }}
//           />
//           <div className="absolute -top-10 -left-10 w-64 h-64 bg-blue-400 rounded-full opacity-10 blur-3xl" />
//           <div className="absolute -bottom-10 right-20 w-80 h-80 bg-blue-300 rounded-full opacity-10 blur-3xl" />
//           <div className="relative w-full px-4 md:px-8 lg:px-10 py-10 md:py-12">
//             <button
//               onClick={() => navigate(-1)}
//               className="flex items-center gap-2 text-white/50 hover:text-white text-xs font-medium mb-5 transition-colors"
//             >
//               <ArrowLeft className="w-3.5 h-3.5" />
//               Back to Candidates
//             </button>
//             <div className="flex items-start justify-between gap-4 flex-wrap mb-6">
//               <div>
//                 <div className="flex items-center gap-2 mb-2">
//                   <span className="text-[10px] font-bold uppercase tracking-widest text-blue-300">Hirees</span>
//                   <span className="w-1 h-1 rounded-full bg-blue-400 opacity-60" />
//                   <span className="text-[10px] font-semibold text-white/40 uppercase tracking-widest">Applicant Database</span>
//                 </div>
//                 <h1 className="text-white text-2xl md:text-3xl font-bold leading-tight mb-2">
//                   Hirees <span className="text-blue-300">Candidate</span> Search
//                 </h1>
//                 <p className="text-white/50 text-sm max-w-xl">
//                   Search across your full Hirees applicant database in real time — results are fetched
//                   page by page, so this stays fast even with 300,000+ resumes.
//                 </p>
//               </div>
//               <div className="flex items-center gap-2 bg-white/10 border border-white/10 rounded-xl px-4 py-2">
//                 <Database className="w-3.5 h-3.5 text-white/60" />
//                 <span className="text-white text-xs font-semibold">
//                   {totalCount ? totalCount.toLocaleString() : "—"} found
//                 </span>
//               </div>
//             </div>

//             {/* ── Hirees-style search fields (main fields only) ── */}
//             <div className="bg-white/5 border border-white/10 rounded-2xl p-4">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
//                 <div className={fieldWrapCls}>
//                   <label className={labelCls}>Keywords</label>
//                   <input
//                     type="text"
//                     placeholder="e.g. React, JavaScript"
//                     className={inputCls}
//                     value={keywords}
//                     onChange={(e) => setKeywords(e.target.value)}
//                     onKeyDown={(e) => e.key === "Enter" && handleSearch()}
//                   />
//                 </div>
//                 <div className={fieldWrapCls}>
//                   <label className={labelCls}>Job Title</label>
//                   <input
//                     type="text"
//                     placeholder='e.g. "Java Developer"'
//                     className={inputCls}
//                     value={jobTitleInput}
//                     onChange={(e) => setJobTitleInput(e.target.value)}
//                     onKeyDown={(e) => e.key === "Enter" && handleSearch()}
//                   />
//                 </div>
//               </div>
//               <div className="flex items-center gap-3 flex-wrap">
//                 <div className={`${fieldWrapCls} flex-1 min-w-[160px]`}>
//                   <label className={labelCls}>Country</label>
//                   <input
//                     type="text"
//                     placeholder="United States"
//                     className={inputCls}
//                     value={country}
//                     onChange={(e) => setCountry(e.target.value)}
//                     onKeyDown={(e) => e.key === "Enter" && handleSearch()}
//                   />
//                 </div>
//                 <div className={`${fieldWrapCls} flex-1 min-w-[160px]`}>
//                   <label className={labelCls}>State</label>
//                   <input
//                     type="text"
//                     placeholder="New Jersey"
//                     className={inputCls}
//                     value={stateInput}
//                     onChange={(e) => setStateInput(e.target.value)}
//                     onKeyDown={(e) => e.key === "Enter" && handleSearch()}
//                   />
//                 </div>
//                 <div className={`${fieldWrapCls} flex-1 min-w-[160px]`}>
//                   <label className={labelCls}>City</label>
//                   <input
//                     type="text"
//                     placeholder="Jersey City"
//                     className={inputCls}
//                     value={city}
//                     onChange={(e) => setCity(e.target.value)}
//                     onKeyDown={(e) => e.key === "Enter" && handleSearch()}
//                   />
//                 </div>
//                 <button
//                   onClick={handleSearch}
//                   className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-red-500 to-orange-500 text-white text-sm font-semibold rounded-xl transition-colors shadow-sm"
//                 >
//                   <Search className="w-4 h-4" />
//                   Search
//                 </button>
//                 <button
//                   onClick={handleReset}
//                   className="flex items-center gap-2 px-4 py-3 border border-white/20 text-white/70 hover:text-white hover:border-white/40 text-sm font-medium rounded-xl transition-colors"
//                 >
//                   <RotateCcw className="w-3.5 h-3.5" />
//                   Reset
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ── Tab bar ───────────────────────────────────────────────────── */}
//         <div className="bg-white border-b border-gray-100 sticky top-0 z-30 shadow-sm">
//           <div className="w-full px-4 md:px-8 lg:px-10 flex gap-0">
//             {TABS.map(({ id, label, icon: Icon }) => (
//               <button
//                 key={id}
//                 onClick={() => setActiveTab(id)}
//                 className={`flex items-center gap-2 px-5 py-3.5 text-sm font-medium border-b-2 transition-all whitespace-nowrap
//                   ${activeTab === id
//                     ? "border-[#012760] text-[#012760]"
//                     : "border-transparent text-gray-400 hover:text-gray-600 hover:border-gray-200"
//                   }`}
//               >
//                 <Icon className="w-3.5 h-3.5" />
//                 {label}
//               </button>
//             ))}
//           </div>
//         </div>

//         <div className="w-full px-4 md:px-8 lg:px-10 py-8">
//           {/* ══════════════════════ TAB: Search ══════════════════════ */}
//           {activeTab === "search" && (
//             <div>
//               <div className="flex items-center justify-between mb-4">
//                 <p className="text-sm font-semibold text-gray-700">
//                   {loading ? (
//                     <span className="flex items-center gap-2 text-gray-400">
//                       <Loader2 className="w-3.5 h-3.5 animate-spin" /> Loading…
//                     </span>
//                   ) : (
//                     <>
//                       {totalCount.toLocaleString()}{" "}
//                       <span className="font-normal text-gray-400">
//                         {totalCount === 1 ? "candidate" : "candidates"} found
//                       </span>
//                     </>
//                   )}
//                 </p>
//                 <div className="flex items-center gap-3">
//                   <button
//                     onClick={handleRefresh}
//                     className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 bg-white hover:border-gray-300 shadow-sm transition-all"
//                   >
//                     <RefreshCw className="w-3.5 h-3.5" />
//                     Refresh
//                   </button>
//                   <button className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 bg-white hover:border-gray-300 shadow-sm transition-all">
//                     <Download className="w-3.5 h-3.5" />
//                     Export
//                   </button>
//                 </div>
//               </div>

//               {error && (
//                 <div className="bg-red-50 border border-red-200 rounded-2xl p-5 mb-4 flex items-center gap-3">
//                   <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0" />
//                   <p className="text-sm text-red-700">{error}</p>
//                   <button
//                     onClick={handleRefresh}
//                     className="ml-auto text-xs font-medium text-red-600 hover:text-red-800 underline"
//                   >
//                     Retry
//                   </button>
//                 </div>
//               )}

//               {!loading && candidates.length === 0 && !error ? (
//                 <div className="bg-white rounded-2xl border border-gray-100 p-14 text-center shadow-sm">
//                   <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
//                     <X className="w-5 h-5 text-gray-400" />
//                   </div>
//                   <p className="text-gray-700 font-semibold mb-1">No candidates found</p>
//                   <p className="text-gray-400 text-sm">Try different keywords or clearing a field</p>
//                 </div>
//               ) : (
//                 <div className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden">
//                   <div
//                     className="overflow-auto"
//                     style={{ maxHeight: "calc(100vh - 320px)" }}
//                   >
//                     <table className="min-w-full text-sm">
//                       <thead className="sticky top-0 z-10">
//                         <tr className="bg-[#eef1fb] border-b border-[#012760]/10">
//                           <th className="w-10 px-3 py-3">
//                             <input
//                               type="checkbox"
//                               checked={candidates.length > 0 && selectedIds.size === candidates.length}
//                               onChange={toggleSelectAll}
//                               className="rounded border-gray-300 accent-[#012760]"
//                             />
//                           </th>
//                           {[
//                             "NAME", "EMAIL ID", "CONTACT NUMBER", "JOB TITLE", "EXPERIENCE",
//                             "CURRENT EMPLOYER", "LOCATION", "WORK AUTHORIZATION",
//                             "NOTICE PERIOD", "RESUME UPDATED ON", "",
//                           ].map((label) => (
//                             <th
//                               key={label}
//                               className="px-3 py-3 text-left text-[11px] font-semibold text-[#012760] tracking-wide whitespace-nowrap"
//                             >
//                               {label}
//                             </th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {candidates.map((c) => (
//                           <tr
//                             key={c.id}
//                             className="border-b border-gray-50 hover:bg-[#012760]/5 transition-colors"
//                           >
//                             <td className="px-3 py-2.5">
//                               <input
//                                 type="checkbox"
//                                 checked={selectedIds.has(c.id)}
//                                 onChange={() => toggleRow(c.id)}
//                                 className="rounded border-gray-300 accent-[#012760]"
//                               />
//                             </td>
//                             <td className="px-3 py-2.5 text-[#012760] font-medium whitespace-nowrap">{c.name}</td>
//                             <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">{c.email || "N/A"}</td>
//                             <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">{c.phone || "N/A"}</td>
//                             <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap max-w-[160px] truncate" title={c.jobTitle}>
//                               {c.jobTitle || "N/A"}
//                             </td>
//                             <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">
//                               {c.experience != null ? `${c.experience} yrs` : "N/A"}
//                             </td>
//                             <td className="px-3 py-2.5 text-gray-400 whitespace-nowrap">N/A</td>
//                             <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap max-w-[180px] truncate" title={c.location}>
//                               {c.location || "N/A"}
//                             </td>
//                             <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">{c.visaType}</td>
//                             <td className="px-3 py-2.5 text-gray-400 whitespace-nowrap">N/A</td>
//                             <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">{c.updatedAt || "N/A"}</td>
//                             <td className="px-3 py-2.5 whitespace-nowrap">
//                               <div className="flex items-center gap-2">
//                                 {c.ceipalProfileUrl || c.linkedinUrl ? (
//                                   <a
//                                     href={c.ceipalProfileUrl || c.linkedinUrl}
//                                     target="_blank"
//                                     rel="noreferrer"
//                                     className="flex items-center gap-1.5 text-[11px] border rounded-lg px-2.5 py-1 font-medium text-[#012760] border-[#012760] hover:bg-[#012760] hover:text-white transition-all w-fit"
//                                   >
//                                     <ExternalLink className="w-3 h-3" /> View
//                                   </a>
//                                 ) : (
//                                   <span className="text-[11px] text-gray-300">—</span>
//                                 )}
//                                 {c.resumeToken ? (
//                                   <a
//                                     href={`${USER_API_END_POINT}/ceipal/candidates/${c.id}/resume?resumeToken=${encodeURIComponent(c.resumeToken)}`}
//                                     target="_blank"
//                                     rel="noreferrer"
//                                     className="flex items-center gap-1.5 text-[11px] border rounded-lg px-2.5 py-1 font-medium text-orange-600 border-orange-500 hover:bg-orange-500 hover:text-white transition-all w-fit"
//                                   >
//                                     Resume
//                                   </a>
//                                 ) : (
//                                   <span className="text-[11px] text-gray-300">—</span>
//                                 )}
//                               </div>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}

//               {totalCount > 0 && (
//                 <Pagination
//                   currentPage={currentPage}
//                   totalPages={totalPages}
//                   onPageChange={handlePageChange}
//                   pageSize={pageSize}
//                   totalItems={totalCount}
//                   onPageSizeChange={handlePageSizeChange}
//                 />
//               )}
//             </div>
//           )}

//           {/* ══════════════════════ TAB: Analytics ══════════════════════ */}
//           {activeTab === "analytics" && (
//             <div>
//               {analyticsLoading ? (
//                 <div className="flex items-center justify-center h-48 text-gray-400 gap-2">
//                   <Loader2 className="w-4 h-4 animate-spin" /> Loading analytics…
//                 </div>
//               ) : analyticsError ? (
//                 <div className="bg-red-50 border border-red-200 rounded-2xl p-5 flex items-center gap-3">
//                   <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0" />
//                   <p className="text-sm text-red-700">{analyticsError}</p>
//                 </div>
//               ) : (
//                 <>
//                   <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
//                     {[
//                       { label: "Total in Ceipal", value: analytics?.totalCount ?? "—", icon: Database, color: "text-[#012760]", bg: "bg-[#f0f4ff]" },
//                       { label: "Avg Experience", value: analytics?.avgExperience ? `${analytics.avgExperience}y` : "—", icon: TrendingUp, color: "text-purple-700", bg: "bg-purple-50" },
//                       { label: "US Citizens / GC", value: analytics?.citizenCount ?? "—", icon: CheckCircle, color: "text-green-700", bg: "bg-green-50" },
//                       { label: "Need Sponsorship", value: analytics?.sponsorshipCount ?? "—", icon: AlertCircle, color: "text-orange-600", bg: "bg-orange-50" },
//                     ].map(({ label, value, icon: Icon, color, bg }) => (
//                       <div key={label} className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
//                         <div className={`w-9 h-9 rounded-xl ${bg} flex items-center justify-center mb-3`}>
//                           <Icon className={`w-4 h-4 ${color}`} />
//                         </div>
//                         <p className="text-2xl font-bold text-gray-800 mb-0.5">{value}</p>
//                         <p className="text-xs text-gray-400">{label}</p>
//                       </div>
//                     ))}
//                   </div>

//                   <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
//                     <div className="flex items-center gap-2 mb-5">
//                       <TrendingUp className="w-4 h-4 text-[#012760]" />
//                       <p className="text-sm font-semibold text-[#012760]">Top Skills Across Ceipal</p>
//                     </div>
//                     {analytics?.topSkills?.length ? (
//                       <div className="space-y-4">
//                         {analytics.topSkills.map(({ skill, count }, i) => {
//                           const max = analytics.topSkills[0].count || 1;
//                           const colors = ["bg-[#012760]", "bg-blue-500", "bg-indigo-500", "bg-orange-400", "bg-purple-500"];
//                           return (
//                             <div key={skill}>
//                               <div className="flex justify-between text-xs mb-1.5">
//                                 <span className="text-gray-700 font-medium truncate max-w-[220px]">{skill}</span>
//                                 <span className="text-gray-400 ml-2 flex-shrink-0">{count.toLocaleString()} resumes</span>
//                               </div>
//                               <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
//                                 <div className={`h-full ${colors[i % colors.length]} rounded-full`} style={{ width: `${(count / max) * 100}%` }} />
//                               </div>
//                             </div>
//                           );
//                         })}
//                       </div>
//                     ) : (
//                       <p className="text-xs text-gray-400">
//                         Backend hasn't returned top-skills aggregation yet — see the `/ceipal/analytics`
//                         stub in ceipalRoutes.example.js.
//                       </p>
//                     )}
//                   </div>
//                 </>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default CeipalDBPage;



import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeft, Search, X, CheckCircle, AlertCircle,
  Loader2, TrendingUp, RefreshCw, Download, ExternalLink,
  BarChart2, Database, RotateCcw,
  FileText,
  Eye,
  Linkedin,
} from "lucide-react";
import { USER_API_END_POINT } from "@/utils/constant";
import Footer from "../Footer";
import Pagination from "./Pagination";

const TABS = [
  { id: "search", label: "Search Hirees", icon: Search },
  { id: "analytics", label: "Analytics", icon: BarChart2 },
];

function mapCeipalRecordToCandidate(item, index) {
  const rawSkills = item.primary_skills || item.skills || "";
  const skills = Array.isArray(rawSkills)
    ? rawSkills
    : String(rawSkills).split(",").map((s) => s.trim()).filter(Boolean);

  return {
    id: item.applicant_id || item.id || `ceipal-${index}`,
    name: [item.first_name, item.middle_name, item.last_name].filter(Boolean).join(" ") || "Unknown",
    email: item.email_address || null,
    phone: item.mobile_number || item.work_phone_number || item.home_phone_number || null,
    jobTitle: item.job_title || "",
    experience: item.experience ? Number(item.experience) : null,
    skills,
    visaType: item.work_authorization || "Unspecified",
    location: [item.city, item.state, item.country].filter(Boolean).join(", "),
    linkedinUrl: item.linkedin_profile_url || null,
    ceipalProfileUrl: item.profile_url || null,
    updatedAt: item.resume_updated_on || item.modified_date || null,
    resumeToken: item.resume_token || null,
  };
}

// Default filters — empty means "no filter applied", used both on first load
// and whenever the user hits Reset + Search again.
const EMPTY_FILTERS = {
  keywords: "",
  jobTitle: "",
  country: "",
  state: "",
  city: "",
};

const CeipalDBPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("search");

  const [keywords, setKeywords] = useState("");
  const [jobTitleInput, setJobTitleInput] = useState("");
  const [country, setCountry] = useState("");
  const [stateInput, setStateInput] = useState("");
  const [city, setCity] = useState("");

  // IMPORTANT: appliedFilters now starts as EMPTY_FILTERS (not null) so that
  // the data-fetch effect below fires immediately on page load, pulling the
  // full (paginated) dataset with no filters applied.
  const [appliedFilters, setAppliedFilters] = useState(EMPTY_FILTERS);

  const [candidates, setCandidates] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [selectedIds, setSelectedIds] = useState(new Set());
  // Collapses the big hero filter panel into a slim bar after a search is run,
  // so the results table gets more vertical space. Starts expanded since
  // nothing has been searched yet on first load.
  const [filtersCollapsed, setFiltersCollapsed] = useState(false);
  const toggleSelectAll = () => {
    setSelectedIds((prev) =>
      prev.size === candidates.length ? new Set() : new Set(candidates.map((c) => c.id))
    );
  };
  const toggleRow = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const [analytics, setAnalytics] = useState(null);
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const [analyticsError, setAnalyticsError] = useState(null);

  const fetchCandidates = useCallback(async (filters, page, size) => {
    setLoading(true);
    setError(null);
    try {
      // Build params with job_title first so it's always the leading/primary
      // filter sent to the backend, followed by the rest in order.
      const params = new URLSearchParams({
        page,
        pageSize: size,
        ...(filters.jobTitle ? { jobTitle: filters.jobTitle } : {}),
        ...(filters.keywords ? { keywords: filters.keywords } : {}),
        ...(filters.country ? { country: filters.country } : {}),
        ...(filters.state ? { state: filters.state } : {}),
        ...(filters.city ? { city: filters.city } : {}),
      });

      const res = await fetch(`${USER_API_END_POINT}/ceipal/candidates?${params}`, {
        credentials: "include",
      });
      const data = await res.json();

      if (!data.success) throw new Error(data.message || "Failed to load Ceipal candidates");

      const list = Array.isArray(data.results) ? data.results : data.data || [];
      setCandidates(list.map(mapCeipalRecordToCandidate));
      setTotalCount(data.total ?? list.length);
    } catch (err) {
      console.error("Error fetching Ceipal candidates:", err);
      setError(err.message || "Failed to load Ceipal candidates");
    } finally {
      setLoading(false);
    }
  }, []);

  // Runs on mount (appliedFilters starts populated) AND whenever filters,
  // page, or page size change afterwards.
  useEffect(() => {
    fetchCandidates(appliedFilters, currentPage, pageSize);
  }, [appliedFilters, currentPage, pageSize, fetchCandidates]);

  useEffect(() => {
    setSelectedIds(new Set());
  }, [candidates]);

  useEffect(() => {
    if (activeTab !== "analytics") return;
    const fetchAnalytics = async () => {
      setAnalyticsLoading(true);
      setAnalyticsError(null);
      try {
        const res = await fetch(`${USER_API_END_POINT}/ceipal/analytics`, { credentials: "include" });
        const data = await res.json();
        if (!data.success) throw new Error(data.message || "Failed to load analytics");
        setAnalytics(data.analytics);
      } catch (err) {
        setAnalyticsError(err.message || "Failed to load analytics");
      } finally {
        setAnalyticsLoading(false);
      }
    };
    fetchAnalytics();
  }, [activeTab]);

  const activeFilterSummary = [
    appliedFilters.jobTitle && `Job Title: ${appliedFilters.jobTitle}`,
    appliedFilters.keywords && `Keywords: ${appliedFilters.keywords}`,
    appliedFilters.country && `Country: ${appliedFilters.country}`,
    appliedFilters.state && `State: ${appliedFilters.state}`,
    appliedFilters.city && `City: ${appliedFilters.city}`,
  ]
    .filter(Boolean)
    .join("  •  ") || "All candidates";

  const handleSearch = () => {
    setCurrentPage(1);
    setAppliedFilters({
      // job_title is the primary filter — put first for clarity, though
      // object key order doesn't affect behavior, fetchCandidates handles priority.
      jobTitle: jobTitleInput.trim(),
      keywords: keywords.trim(),
      country: country.trim(),
      state: stateInput.trim(),
      city: city.trim(),
    });
    setFiltersCollapsed(true);
  };

  const handleReset = () => {
    setKeywords("");
    setJobTitleInput("");
    setCountry("");
    setStateInput("");
    setCity("");
    setCurrentPage(1);
    // Reset also re-triggers a full, unfiltered load immediately, and
    // re-expands the filter panel since there's nothing active to summarize.
    setAppliedFilters(EMPTY_FILTERS);
    setFiltersCollapsed(false);
  };

  const handleRefresh = () => {
    fetchCandidates(appliedFilters, currentPage, pageSize);
  };

  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  const handlePageChange = (page) => setCurrentPage(page);
  const handlePageSizeChange = (size) => {
    setPageSize(parseInt(size, 10));
    setCurrentPage(1);
  };

  const inputCls =
    "w-full text-sm text-gray-700 placeholder-gray-400 bg-transparent outline-none";
  const fieldWrapCls =
    "flex flex-col gap-1 bg-white rounded-xl px-3 py-2 shadow-sm border border-white/10";
  const labelCls = "text-[9px] font-bold uppercase tracking-widest text-gray-400";

  return (
    <>
      <div className="min-h-screen bg-[#f8f9fc]">
        {/* ── Hero ──────────────────────────────────────────────────────── */}
        <div className="relative w-full overflow-hidden">
          <div className="absolute inset-0 bg-[#012760]" />
          <div
            className="absolute inset-0 opacity-[0.07]"
            style={{
              backgroundImage: "radial-gradient(circle, #ffffff 1px, transparent 1px)",
              backgroundSize: "28px 28px",
            }}
          />
          <div className="absolute -top-10 -left-10 w-64 h-64 bg-blue-400 rounded-full opacity-10 blur-3xl" />
          <div className="absolute -bottom-10 right-20 w-80 h-80 bg-blue-300 rounded-full opacity-10 blur-3xl" />
          <div className={`relative w-full px-4 md:px-8 lg:px-10 transition-all ${filtersCollapsed ? "py-4 md:py-5" : "py-10 md:py-12"}`}>
            <button
              onClick={() => navigate(-1)}
              className={`flex items-center gap-2 text-white/50 hover:text-white text-xs font-medium transition-colors ${filtersCollapsed ? "mb-3" : "mb-5"}`}
            >
              <ArrowLeft className="w-3.5 h-3.5" />
              Back to Candidates
            </button>
            <div className={`flex items-start justify-between gap-4 flex-wrap ${filtersCollapsed ? "mb-3" : "mb-6"}`}>
              <div>
                {!filtersCollapsed && (
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-[10px] font-bold uppercase tracking-widest text-blue-300">Hirees</span>
                    <span className="w-1 h-1 rounded-full bg-blue-400 opacity-60" />
                    <span className="text-[10px] font-semibold text-white/40 uppercase tracking-widest">Applicant Database</span>
                  </div>
                )}
                <h1 className={`text-white font-bold leading-tight transition-all ${filtersCollapsed ? "text-lg mb-0" : "text-2xl md:text-3xl mb-2"}`}>
                  Hirees <span className="text-blue-300">Candidate</span> Search
                </h1>
                {!filtersCollapsed && (
                  <p className="text-white/50 text-sm max-w-xl">
                    Search across your full Hirees applicant database in real time — results are fetched
                    page by page, so this stays fast even with 300,000+ resumes.
                  </p>
                )}
              </div>
              <div className="flex items-center gap-2 bg-white/10 border border-white/10 rounded-xl px-4 py-2">
                <Database className="w-3.5 h-3.5 text-white/60" />
                <span className="text-white text-xs font-semibold">
                  {totalCount ? totalCount.toLocaleString() : "—"} found
                </span>
              </div>
            </div>

            {filtersCollapsed ? (
              /* ── Compact filter summary bar (shown after a search) ── */
              <div className="bg-white/5 border border-white/10 rounded-2xl px-4 py-3 flex items-center justify-between gap-3 flex-wrap">
                <div className="flex items-center gap-2 min-w-0">
                  <Search className="w-3.5 h-3.5 text-white/40 flex-shrink-0" />
                  <span className="text-white/80 text-sm font-medium truncate">
                    {activeFilterSummary}
                  </span>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <button
                    onClick={() => setFiltersCollapsed(false)}
                    className="flex items-center gap-1.5 px-3 py-1.5 border border-white/20 text-white/70 hover:text-white hover:border-white/40 text-xs font-medium rounded-lg transition-colors"
                  >
                    Edit filters
                  </button>
                  <button
                    onClick={handleReset}
                    className="flex items-center gap-1.5 px-3 py-1.5 border border-white/20 text-white/70 hover:text-white hover:border-white/40 text-xs font-medium rounded-lg transition-colors"
                  >
                    <RotateCcw className="w-3 h-3" />
                    Reset
                  </button>
                </div>
              </div>
            ) : (
              /* ── Hirees-style search fields (main fields only) ── */
              <div className="bg-white/5 border border-white/10 rounded-2xl p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                  <div className={fieldWrapCls}>
                    <label className={labelCls}>Keywords</label>
                    <input
                      type="text"
                      placeholder="e.g. React, JavaScript"
                      className={inputCls}
                      value={keywords}
                      onChange={(e) => setKeywords(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                    />
                  </div>
                  <div className={fieldWrapCls}>
                    <label className={labelCls}>Job Title</label>
                    <input
                      type="text"
                      placeholder='e.g. "Java Developer"'
                      className={inputCls}
                      value={jobTitleInput}
                      onChange={(e) => setJobTitleInput(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                    />
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-wrap">
                  <div className={`${fieldWrapCls} flex-1 min-w-[160px]`}>
                    <label className={labelCls}>Country</label>
                    <input
                      type="text"
                      placeholder="United States"
                      className={inputCls}
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                    />
                  </div>
                  <div className={`${fieldWrapCls} flex-1 min-w-[160px]`}>
                    <label className={labelCls}>State</label>
                    <input
                      type="text"
                      placeholder="New Jersey"
                      className={inputCls}
                      value={stateInput}
                      onChange={(e) => setStateInput(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                    />
                  </div>
                  <div className={`${fieldWrapCls} flex-1 min-w-[160px]`}>
                    <label className={labelCls}>City</label>
                    <input
                      type="text"
                      placeholder="Jersey City"
                      className={inputCls}
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                    />
                  </div>
                  <button
                    onClick={handleSearch}
                    className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-red-500 to-orange-500 text-white text-sm font-semibold rounded-xl transition-colors shadow-sm"
                  >
                    <Search className="w-4 h-4" />
                    Search
                  </button>
                  <button
                    onClick={handleReset}
                    className="flex items-center gap-2 px-4 py-3 border border-white/20 text-white/70 hover:text-white hover:border-white/40 text-sm font-medium rounded-xl transition-colors"
                  >
                    <RotateCcw className="w-3.5 h-3.5" />
                    Reset
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ── Tab bar ───────────────────────────────────────────────────── */}
        <div className="bg-white border-b border-gray-100 sticky top-0 z-30 shadow-sm">
          <div className="w-full px-4 md:px-8 lg:px-10 flex gap-0">
            {TABS.map(({ id, label, icon: Icon }) => (
              <button
                key={id}
                onClick={() => setActiveTab(id)}
                className={`flex items-center gap-2 px-5 py-3.5 text-sm font-medium border-b-2 transition-all whitespace-nowrap
                  ${activeTab === id
                    ? "border-[#012760] text-[#012760]"
                    : "border-transparent text-gray-400 hover:text-gray-600 hover:border-gray-200"
                  }`}
              >
                <Icon className="w-3.5 h-3.5" />
                {label}
              </button>
            ))}
          </div>
        </div>

        <div className="w-full px-4 md:px-8 lg:px-10 py-8">
          {/* ══════════════════════ TAB: Search ══════════════════════ */}
          {activeTab === "search" && (
            <div>
              <div className="flex items-center justify-between mb-4">
                <p className="text-sm font-semibold text-gray-700">
                  {loading ? (
                    <span className="flex items-center gap-2 text-gray-400">
                      <Loader2 className="w-3.5 h-3.5 animate-spin" /> Loading…
                    </span>
                  ) : (
                    <>
                      {totalCount.toLocaleString()}{" "}
                      <span className="font-normal text-gray-400">
                        {totalCount === 1 ? "candidate" : "candidates"} found
                      </span>
                    </>
                  )}
                </p>
                <div className="flex items-center gap-3">
                  <button
                    onClick={handleRefresh}
                    className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 bg-white hover:border-gray-300 shadow-sm transition-all"
                  >
                    <RefreshCw className="w-3.5 h-3.5" />
                    Refresh
                  </button>
                  <button className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 bg-white hover:border-gray-300 shadow-sm transition-all">
                    <Download className="w-3.5 h-3.5" />
                    Export
                  </button>
                </div>
              </div>

              {error && (
                <div className="bg-red-50 border border-red-200 rounded-2xl p-5 mb-4 flex items-center gap-3">
                  <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0" />
                  <p className="text-sm text-red-700">{error}</p>
                  <button
                    onClick={handleRefresh}
                    className="ml-auto text-xs font-medium text-red-600 hover:text-red-800 underline"
                  >
                    Retry
                  </button>
                </div>
              )}

              {!loading && candidates.length === 0 && !error ? (
                <div className="bg-white rounded-2xl border border-gray-100 p-14 text-center shadow-sm">
                  <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
                    <X className="w-5 h-5 text-gray-400" />
                  </div>
                  <p className="text-gray-700 font-semibold mb-1">No candidates found</p>
                  <p className="text-gray-400 text-sm">Try different keywords or clearing a field</p>
                </div>
              ) : (
                <div className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden">
                  <div
                    className="overflow-auto"
                    style={{ maxHeight: "calc(100vh - 320px)" }}
                  >
                    <table className="min-w-full text-xs">
                      <thead className="sticky top-0 z-10">
                        <tr className="bg-[#eef1fb] border-b border-[#012760]/10">
                          <th className="w-8 px-2.5 py-2">
                            <input
                              type="checkbox"
                              checked={candidates.length > 0 && selectedIds.size === candidates.length}
                              onChange={toggleSelectAll}
                              className="rounded border-gray-300 accent-[#012760]"
                            />
                          </th>
                          {[
                            "RESUME","LINKDIN","ACTIONS","NAME", "EMAIL ID", "CONTACT NUMBER", "JOB TITLE", "EXPERIENCE",
                            "CURRENT EMPLOYER", "LOCATION", "WORK AUTHORIZATION",
                            "NOTICE PERIOD", "RESUME UPDATED ON", "",
                          ].map((label) => (
                            <th
                              key={label}
                              className="px-2.5 py-2 text-left text-[10px] font-semibold text-[#012760] tracking-wide whitespace-nowrap"
                            >
                              {label}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
  {candidates.map((c) => (
    <tr
      key={c.id}
      className="border-b border-gray-50 hover:bg-[#012760]/5 transition-colors"
    >
      {/* Checkbox */}
      <td className="px-2.5 py-1.5">
        <input
          type="checkbox"
          checked={selectedIds.has(c.id)}
          onChange={() => toggleRow(c.id)}
          className="rounded border-gray-300 accent-[#012760]"
        />
      </td>

      {/* Resume */}
      <td className="px-2.5 py-1.5 text-center">
        {c.resumeToken ? (
          <FileText className="w-4 h-4 text-orange-600 mx-auto" />
        ) : (
          <span className="text-gray-300">—</span>
        )}
      </td>

      {/* LinkedIn */}
      <td className="px-2.5 py-1.5 text-center">
        {c.ceipalProfileUrl || c.linkedinUrl ? (
          <a
            href={c.ceipalProfileUrl || c.linkedinUrl}
            target="_blank"
            rel="noreferrer"
            title="View LinkedIn Profile"
            className="text-[#0077B5] hover:text-[#005582]"
          >
            <Linkedin className="w-4 h-4 mx-auto" />
          </a>
        ) : (
          <span className="text-gray-300">—</span>
        )}
      </td>

      {/* Actions */}
      <td className="px-2.5 py-1.5">
        <div className="flex items-center justify-center gap-2">
          {c.resumeToken ? (
            <>
              {/* View Resume */}
              <a
                href={`${USER_API_END_POINT}/ceipal/candidates/${c.id}/resume?resumeToken=${encodeURIComponent(
                  c.resumeToken
                )}`}
                target="_blank"
                rel="noreferrer"
                title="View Resume"
                className="text-[#012760] hover:text-blue-600"
              >
                <Eye className="w-4 h-4" />
              </a>

              {/* Download Resume */}
              <a
                href={`${USER_API_END_POINT}/ceipal/candidates/${c.id}/resume?resumeToken=${encodeURIComponent(
                  c.resumeToken
                )}`}
                download
                title="Download Resume"
                className="text-green-600 hover:text-green-700"
              >
                <Download className="w-4 h-4" />
              </a>
            </>
          ) : (
            <span className="text-gray-300">—</span>
          )}
        </div>
      </td>

      {/* Name */}
      <td className="px-2.5 py-1.5 text-[#012760] font-medium whitespace-nowrap">
        {c.name}
      </td>

      {/* Email */}
      <td className="px-2.5 py-1.5 text-gray-600 whitespace-nowrap">
        {c.email || "N/A"}
      </td>

      {/* Phone */}
      <td className="px-2.5 py-1.5 text-gray-600 whitespace-nowrap">
        {c.phone || "N/A"}
      </td>

      {/* Job Title */}
      <td
        className="px-2.5 py-1.5 text-gray-600 whitespace-nowrap max-w-[160px] truncate"
        title={c.jobTitle}
      >
        {c.jobTitle || "N/A"}
      </td>

      {/* Experience */}
      <td className="px-2.5 py-1.5 text-gray-600 whitespace-nowrap">
        {c.experience != null ? `${c.experience} yrs` : "N/A"}
      </td>

      {/* Rate */}
      <td className="px-2.5 py-1.5 text-gray-400 whitespace-nowrap">
        N/A
      </td>

      {/* Location */}
      <td
        className="px-2.5 py-1.5 text-gray-600 whitespace-nowrap max-w-[180px] truncate"
        title={c.location}
      >
        {c.location || "N/A"}
      </td>

      {/* Visa */}
      <td className="px-2.5 py-1.5 text-gray-600 whitespace-nowrap">
        {c.visaType || "N/A"}
      </td>

      {/* Availability */}
      <td className="px-2.5 py-1.5 text-gray-400 whitespace-nowrap">
        N/A
      </td>

      {/* Updated */}
      <td className="px-2.5 py-1.5 text-gray-600 whitespace-nowrap">
        {c.updatedAt || "N/A"}
      </td>
    </tr>
  ))}
</tbody>
                    </table>
                  </div>
                </div>
              )}

              {totalCount > 0 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  pageSize={pageSize}
                  totalItems={totalCount}
                  onPageSizeChange={handlePageSizeChange}
                />
              )}
            </div>
          )}

          {/* ══════════════════════ TAB: Analytics ══════════════════════ */}
          {activeTab === "analytics" && (
            <div>
              {analyticsLoading ? (
                <div className="flex items-center justify-center h-48 text-gray-400 gap-2">
                  <Loader2 className="w-4 h-4 animate-spin" /> Loading analytics…
                </div>
              ) : analyticsError ? (
                <div className="bg-red-50 border border-red-200 rounded-2xl p-5 flex items-center gap-3">
                  <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0" />
                  <p className="text-sm text-red-700">{analyticsError}</p>
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                    {[
                      { label: "Total in Ceipal", value: analytics?.totalCount ?? "—", icon: Database, color: "text-[#012760]", bg: "bg-[#f0f4ff]" },
                      { label: "Avg Experience", value: analytics?.avgExperience ? `${analytics.avgExperience}y` : "—", icon: TrendingUp, color: "text-purple-700", bg: "bg-purple-50" },
                      { label: "US Citizens / GC", value: analytics?.citizenCount ?? "—", icon: CheckCircle, color: "text-green-700", bg: "bg-green-50" },
                      { label: "Need Sponsorship", value: analytics?.sponsorshipCount ?? "—", icon: AlertCircle, color: "text-orange-600", bg: "bg-orange-50" },
                    ].map(({ label, value, icon: Icon, color, bg }) => (
                      <div key={label} className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
                        <div className={`w-9 h-9 rounded-xl ${bg} flex items-center justify-center mb-3`}>
                          <Icon className={`w-4 h-4 ${color}`} />
                        </div>
                        <p className="text-2xl font-bold text-gray-800 mb-0.5">{value}</p>
                        <p className="text-xs text-gray-400">{label}</p>
                      </div>
                    ))}
                  </div>

                  <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
                    <div className="flex items-center gap-2 mb-5">
                      <TrendingUp className="w-4 h-4 text-[#012760]" />
                      <p className="text-sm font-semibold text-[#012760]">Top Skills Across Ceipal</p>
                    </div>
                    {analytics?.topSkills?.length ? (
                      <div className="space-y-4">
                        {analytics.topSkills.map(({ skill, count }, i) => {
                          const max = analytics.topSkills[0].count || 1;
                          const colors = ["bg-[#012760]", "bg-blue-500", "bg-indigo-500", "bg-orange-400", "bg-purple-500"];
                          return (
                            <div key={skill}>
                              <div className="flex justify-between text-xs mb-1.5">
                                <span className="text-gray-700 font-medium truncate max-w-[220px]">{skill}</span>
                                <span className="text-gray-400 ml-2 flex-shrink-0">{count.toLocaleString()} resumes</span>
                              </div>
                              <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                                <div className={`h-full ${colors[i % colors.length]} rounded-full`} style={{ width: `${(count / max) * 100}%` }} />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <p className="text-xs text-gray-400">
                        Backend hasn't returned top-skills aggregation yet — see the `/ceipal/analytics`
                        stub in ceipalRoutes.example.js.
                      </p>
                    )}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CeipalDBPage;